import { useNavigate, useParams } from "react-router-dom";
import { TemplateBrowser } from "@/components/webbuilder/features/onboarding/TemplateBrowser";

export default function OnboardingTemplatesPage() {
  const navigate = useNavigate();
  const { storeType, storeId } = useParams<{ storeType: string; storeId: string }>();

  const handleBack = () => {
    if (!storeType || !storeId) return;
    navigate(`/${storeType}/${storeId}/webbuilder/onboarding`);
  };

  const handleSelectTemplate = (templateId: string, templateName: string) => {
    if (!storeType || !storeId) return;
    // Navigate to page selection page with template data
    navigate(
      `/${storeType}/${storeId}/webbuilder/onboarding/templates/select?templateId=${templateId}&templateName=${encodeURIComponent(templateName)}`,
    );
  };

  const handleCreateBlank = () => {
    if (!storeType || !storeId) return;
    navigate(`/${storeType}/${storeId}/webbuilder/new-page`);
  };

  return (
    <TemplateBrowser
      onBack={handleBack}
      onSelectTemplate={handleSelectTemplate}
      onCreateBlank={handleCreateBlank}
    />
  );
}
